"use strict";
/**
 * Browser Logging, but taking the stage into account & mind the browser compatibility
 */ var Log = {};
// Ensures there will be no 'console is undefined' errors
window.console = window.console || function() {
    var c = {};
    c.log = c.warn = c.debug = c.info = c.error = c.time = c.dir = c.profile = c.clear = c.exception = c.trace = c.assert = function() {};
    return c;
}();
if (Function.prototype.bind && window.console && typeof console.log === "object") {
    [
        "log",
        "info",
        "warn",
        "error",
        "assert",
        "dir",
        "clear",
        "profile",
        "profileEnd"
    ].forEach(function(method) {
        console[method] = this.bind(console[method], console);
    }, Function.prototype.call);
}
Log.log = function() {};
Log.group = function() {};
Log.groupEnd = function() {};
Log.warn = function() {};
Log.error = function() {};
export default Log;
